import styles from '@features/voucher-new/styles/voucher-new.module.css';
import React from 'react';

import { LOGO_VERSION } from '@shared/config/constants/modules/logo';
import { LanguageSelector } from '@shared/ui/language-selector';

export const VoucherHeader = () => {
  return (
    <div className={styles.voucherHeaderWrapper}>
      <img width={128} height={40} src={LOGO_VERSION.black} alt="logo" />

      <LanguageSelector isSpecial />
    </div>
  );
};
